// dispatch(fetchDocuments("client-ready"));
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { closeViewDocument, fetchDocuments, openViewDocument, resetTabState, updateRequestBody } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import TableComponent from "../../TableComponent/TableComponent";
import ViewDocumentModal from "../Modal/ViewDocumentModal";
import EngageTranslationClientReadyTableColumns from "../TableComponent/EngageTranslationClientReadyTableColumns";
import { TableRowSelection } from "antd/es/table/interface";
import { Table } from "antd";
import EngageTranslateArchivedColumns from "../TableComponent/EngageTranslateArchivedColumns";

function ArchivedContent(props: any) {
  const dispatch = useAppDispatch();
  const archivedTabState = useSelector((state: RootState) => state.engageTranslationState.archivedTabState);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = { ...archivedTabState.currentRequestBody, sortColumn: sorter.field, isAsc: isAscend(sorter.order) };
    dispatch(resetTabState("archived"));
    dispatch(updateRequestBody({ requestBody: newSortingRequestBody, view: "archived" }));
    dispatch(fetchDocuments({ view: "archived" }));
  };

  //   const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
  //     setSelectedRowKeys(newSelectedRowKeys);
  //   };

  //   const rowSelection: TableRowSelection<any> = {
  //     selectedRowKeys: selectedRowKeys,
  //     onChange: onSelectChange,
  //   };

  return (
    <div className="d-flex flex-column full-flex h-100 mt-2 px-2">
      {/* <ViewDocumentModal
        open={() => dispatch(openViewDocument())}
        close={() => dispatch(closeViewDocument())}
        openState={clientReadyTabState.viewDocumentOpenState}
        // record={record}
      /> */}

      <div className="d-flex flex-column full-flex gap-3 overflow-hidden">
        <TableComponent
          dataSource={archivedTabState.data}
          tableKey={"archived"}
          columns={EngageTranslateArchivedColumns}
          loading={archivedTabState.loading}
          //   rowSelection={rowSelection}
          pagination={archivedTabState.pagination}
          handleTableSorting={handleTableSorting}
        />
      </div>
    </div>
  );
}

export default memo(ArchivedContent);
